"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var styles_1 = require("../styles");
var kSearchInputHeight = '2rem';
var container = typestyle_1.style({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridColumnGap: '0.5rem',
});
var input = typestyle_1.style(__assign(__assign({}, styles_1.getTextCSS('body')), { backgroundColor: 'transparent', color: styles_1.getHex('textlight'), border: 'none', borderBottom: "1px solid " + styles_1.getHex('grey1'), textOverflow: 'ellipsis', paddingBottom: '0.2rem', height: kSearchInputHeight, fontSize: '0.75rem', $nest: {
        '&:focus': {
            outline: 'none',
        },
        '&::placeholder': {
            color: styles_1.getHex('grey1'),
        },
    } }));
var icon = typestyle_1.style({
    display: 'flex',
    cursor: 'pointer',
    $nest: {
        '& > svg': {
            width: '24px',
        },
    },
});
exports.styles = {
    container: container,
    input: input,
    icon: icon,
};
